<i18n>
{
    "fr": {
        "history": "Historique de l'activité",
        "loading": "Chargement...",
        "updateFormMessage": "a modifié le formulaire."
    }
}
</i18n>
<template>
  <div class="requestInformation">
    <div class="historyBlock">
      <div class="row historyHeader" style>
        <ul>
          <li class="active">
            <a class="activityBlockLink active" href="#activityBlock" role="tab" data-toggle="tab">
              <span>{{$t('history')}}</span>
            </a>
          </li>
        </ul>
      </div>
      <div class="historyBody">
        <div class="activityBlock">
          <template v-if="loading">
            <strong>{{$t('loading')}}</strong>
            <b-spinner class="ml-auto"></b-spinner>
          </template>
          <article v-else v-for="workflow in workflows" :key="workflow.id">
            <IconHistory/>
            <div class="activityEntry">
              <header>
                <span class="author">
                  <b>{{ workflow.applicationUser.firstName }} {{ workflow.applicationUser.lastName }}</b>
                  {{ getStatusLabel(workflow)}}
                </span>
                <span class="date">le {{ workflow.createdAt|moment("DD/MM/YYYY \à H:mm") }}</span>
              </header>
              <p>{{ workflow.comment }}</p>
            </div>
          </article>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IconHistory from './icons/IconHistory.vue';
import { mapState } from 'vuex';
export default {
  name: 'WorkflowHistory',
  components: {
    IconHistory,
  },
  data: () => ({
    loading: true,
  }),
  created() {
    this.fetchWorkflows();
  },
  computed: {
    ...mapState({
      workflows: state => state.workflow.workflows,
      control: state => state.refControls.control,
    }),
  },
  methods: {
    fetchWorkflows() {
      this.$store.dispatch('fetchWorkflows').then(() => (this.loading = false));
    },
    getStatusLabel(workflow) {
      if (this.control) {
        let ponctuation = workflow.comment ? ':' : '.';
        if (workflow.status.id == 'closed') {
          return `${workflow.status.label}.`;
        } else if (workflow.createdAt != this.control.createdAt && workflow.comment == null) {
          return this.$i18n.t('updateFormMessage');
        }
        return `${workflow.status.label}${ponctuation}`;
      }
    },
  },
};
</script>

